import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Chỉ admin: bộ tag của trang là cấu hình chung cả đội, không phải tuỳ chọn cá
// nhân. API cũng kiểm quyền phía server, đây chỉ là lớp giấu lối vào.
//
// Tên route và đường dẫn GIỮ NGUYÊN dù file đã đổi tên: link cũ đã phát cho
// nhân viên và `helper/subPageMenu.js` đang trỏ vào đó.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tag-trang'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'bonboz_tag_trang_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
